import React from 'react';
import { Link } from 'react-router-dom';

export const HeadingSection = () => {
    return (
        <div className="container-fluid aboutus">
<div className="container">
	<div className="row mb-5">

		<div className="col-sm-12 col-lg-6 align-self-center">
			<div className="aboutus-text">
			<h1>We are Digital Transformers</h1>
			<hr color="white" />
			<h5>We are a design agency that makes beautiful things. We pride ourselves in creating beautiful solutions and meeting challenges.
            </h5>
            <Link role="button" to="/Services" className="btn btn-primary">read more</Link>
            </div>
            <br/>
		</div>
		<div className="col-sm-12 col-lg-6 h-image">
		<img src={'img/sec-1.png'} className="img-fluid" />
		
	     </div>
	</div>

</div>
</div>
    )
}

export default HeadingSection